export const DtiRadialMeterBase = {
  leftTitle: '35%',
  leftLabel: 'or less is good',
  middleTitle: '36% to 43%',
  middleLabel: 'needs work',
  rightTitle: '44%',
  rightLabel: 'or more is high',
  dtiRatio: 0,
}
